/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { isEmpty } from '@ember/utils';
import { CampaignsTriggerSetupDateArgs } from 'cio/components/campaigns/trigger/setup/condition-blocks/date/config';
import pluralize from 'cio/utils/pluralize';

export default class ConditionBlockDate extends Component<CampaignsTriggerSetupDateArgs> {
  get highlight() {
    return isEmpty(this.args.summary);
  }

  get absLeadDays() {
    return Math.abs(this.args.dateTriggeredLeadDays);
  }

  get getTriggerStart() {
    let { dateTriggeredLeadDays } = this.args;
    if (dateTriggeredLeadDays > 0) {
      return `${dateTriggeredLeadDays} ${pluralize(dateTriggeredLeadDays, 'day')} after`;
    }
    if (dateTriggeredLeadDays < 0) {
      return `${this.absLeadDays} ${pluralize(this.absLeadDays, 'day')} before`;
    }
    return 'On the date';
  }
}
